const genericUrl = process.env.REACT_APP_API_URL;

export async function PutShopItemAula(idAula: string, idItem: string, stock: number, hidden: number, isNew: number) {
    try {
        const response = await fetch(`${genericUrl}:8061/jutge/shop/admin/aula/${idAula}/item/${idItem}`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                stock: stock.toString(),
                hidden: hidden.toString(),
                isNew: isNew.toString()
            })
        });

        if (response.ok) return { ok: true };
        else {
            const msg = await response.text();
            return { ok: false, msg };
        }
    } catch (e) {
        console.error(e);
        return { ok: false, msg: "Error de conexión" };
    }
}
